import RequestBuilder from '../Lib/Requests';

export default class GatewayReminderInstanceService {
  api = new RequestBuilder();

  buildGetPaginatedGatewayReminderInstancesRequest(params, cancelToken) {
    return {
      cancelToken,
      endpoint: '/v2/reminder-instance',
      method: 'get',
      params,
      service: 'maintenance',
    };
  }
  async getPaginatedGatewayReminderInstances(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildGetPaginatedGatewayReminderInstancesRequest(params, cancelToken)
    );
    return data;
  }

  buildGetPaginatedOrgReportReminderInstancesRequest(
    orgID,
    params,
    cancelToken
  ) {
    return {
      cancelToken,
      endpoint: `/v2/reminder-instance/${orgID}/report`,
      method: 'get',
      params,
      service: 'maintenance',
    };
  }
  async getPaginatedOrgReportReminderInstances(orgID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildGetPaginatedOrgReportReminderInstancesRequest(
        orgID,
        params,
        cancelToken
      )
    );
    return data;
  }

  buildGetOrgReportReminderInstancesRequestCsv(orgID, params, cancelToken) {
    return {
      cancelToken,
      endpoint: `/v2/reminder-instance/${orgID}/csv`,
      method: 'get',
      params,
      service: 'maintenance',
    };
  }
  async getOrgReportReminderInstancesCsv(orgID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildGetOrgReportReminderInstancesRequestCsv(
        orgID,
        params,
        cancelToken
      )
    );
    return data;
  }

  buildUpdateGatewayReminderInstancesRequest(gatewayID, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: `/v2/reminder-instance/${gatewayID}`,
      method: 'put',
      service: 'maintenance',
    };
  }
  async updateGatewayReminderInstances(gatewayID, body, cancelToken) {
    return this.api.request(
      this.buildUpdateGatewayReminderInstancesRequest(
        gatewayID,
        body,
        cancelToken
      )
    );
  }
}
